// The model object that a Vueform validator's element sits in — its parent object, derived from the
// element's own dotted path. Lets a cross-field rule read its siblings (e.g. an address rule reading the
// Postcode / Country / EntryMode next to the field it validates) without hard-coding the object's key.
// Falls back to the whole model for a top-level element (no parent object).
export function ownerObject(validator: any): Record<string, any>
{
    const form$ = validator?.form$
    const path: string = validator?.element$?.path ?? ''
    const dot = path.lastIndexOf('.')
    if (dot < 0) return form$?.model ?? {}
    const parentPath = path.slice(0, dot)
    return parentPath.split('.').reduce((o: any, k: string) => (o == null ? o : o[k]), form$?.model) ?? {}
}
